module.exports = __webpack_public_path__ + "img/fallback-slide-notext.1280x1280.e60946ef.png";